import { useEffect } from 'react';

const useMount = (callbackFunction, deps = []) => useEffect(callbackFunction, [...deps]);

export default useMount;
